// @ts-ignore
import {Switch} from 'react-native';

interface ToggleProps {
  accessible: boolean;
  value: boolean;
  onPress: () => void;
  thumbActiveComponent: React.ReactNode;
  trackBarStyle: {
    borderColor: string;
  };
  trackBar: {
    width: number;
    height: number;
    borderWidth: number;
    activeBackgroundColor: string;
    inActiveBackgroundColor: string;
  };
  thumbButton: {
    width: number;
    height: number;
    activeBackgroundColor: string;
    inActiveBackgroundColor: string;
  };
}

export default function Toggle(props: ToggleProps) {
  return (
    <Switch
      value={props.value}
      onValueChange={props.onPress}
      thumbColor={
        props.value
          ? props.thumbButton.activeBackgroundColor
          : props.thumbButton.inActiveBackgroundColor
      }
      trackColor={{
        false: props.trackBar.inActiveBackgroundColor,
        true: props.trackBar.activeBackgroundColor,
      }}
    />
  );
}
